import React from 'react';
import {useField} from 'formik';
import Dropdown, {Props as DropdownProps} from 'src/components/dropdown';

/**
  For use in Formik forms.

  Usage example:
  <FormikDropdown name="startDate" options={options} placeholder="Start date" />
*/

const FormikDropdown = (props: {name: string} & DropdownProps) => {
  const [field, meta] = useField(props.name);
  return (
    <Dropdown
      {...props}
      {...field}
      error={meta.touched ? meta.error : ''}
      {...(props.onChange && {
        onChange: (e) => {
          field.onChange(e);
          props.onChange?.(e);
        },
      })}
    />
  );
};

export default FormikDropdown;
